/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Progress_Aria_LabelInputs */

const en_ocr_progress_aria_label = /** @type {(inputs: Ocr_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR processing progress`)
};

const fr_ocr_progress_aria_label = /** @type {(inputs: Ocr_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`État d'avancement du traitement OCR`)
};

const de_ocr_progress_aria_label = /** @type {(inputs: Ocr_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR-Verarbeitungsfortschritt`)
};

const it_ocr_progress_aria_label = /** @type {(inputs: Ocr_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`stato di avanzamento dell'elaborazione OCR`)
};

const ru_ocr_progress_aria_label = /** @type {(inputs: Ocr_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ход обработки OCR`)
};

const es_ocr_progress_aria_label = /** @type {(inputs: Ocr_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`progreso del procesamiento OCR`)
};

const zh_cn2_ocr_progress_aria_label = /** @type {(inputs: Ocr_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR处理进度`)
};

const ja_ocr_progress_aria_label = /** @type {(inputs: Ocr_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OCR処理の進捗状況`)
};

const hi_ocr_progress_aria_label = /** @type {(inputs: Ocr_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओसीआर प्रोसेसिंग प्रगति`)
};

const pt_pt2_ocr_progress_aria_label = /** @type {(inputs: Ocr_Progress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progresso do processamento OCR`)
};

/**
* | output |
* | --- |
* | "OCR processing progress" |
*
* @param {Ocr_Progress_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_progress_aria_label = /** @type {((inputs?: Ocr_Progress_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Progress_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ocr_progress_aria_label(inputs)
	if (locale === "de") return de_ocr_progress_aria_label(inputs)
	if (locale === "it") return it_ocr_progress_aria_label(inputs)
	if (locale === "ru") return ru_ocr_progress_aria_label(inputs)
	if (locale === "es") return es_ocr_progress_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_ocr_progress_aria_label(inputs)
	if (locale === "ja") return ja_ocr_progress_aria_label(inputs)
	if (locale === "hi") return hi_ocr_progress_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_ocr_progress_aria_label(inputs)
	return en_ocr_progress_aria_label(inputs)
});